module.exports = window.__IFENG_INNER_LIBS__["@ifeng/ui_base"];